module.exports = __webpack_public_path__ + "static/media/ic_visa.66d49498.svg";